import styled from 'styled-components'
import theme from 'theme_'
import { Font12, Font14 } from 'components/Typography'

export const CommonStyledInput = styled.input<{ invalid?: boolean }>`
  margin: 0 0 ${theme.spacing.s};
  padding: 0 ${theme.spacing.s};
  height: 40px;
  ${Font14};
  font-family: ${theme.fonts.base};
  line-height: 24px;
  color: ${theme.colors.otterWarmBlack};
  background-color: ${theme.colors.white};
  border: 1px solid ${theme.colors.newLightGrey};
  border-radius: 8px;
  outline: none;
  width: 100%;
  caret-color: ${theme.colors.horizonOrange};

  ::placeholder {
    color: ${theme.colors.darkeyGrey};
  }

  :hover {
    border-color: ${theme.colors.darkeyGrey};
  }
  :active,
  :focus {
    border-color: ${theme.colors.horizonOrange};
  }
  :disabled {
    background-color: ${theme.colors.lighterGrey};
    pointer-events: none;
  }

  ${(p) => p.invalid && `border-color ${theme.colors.error};`};
`

export const CommonStyledTextArea = styled.textarea<{ invalid?: boolean }>`
  margin: 0 0 ${theme.spacing.s};
  padding: 0 ${theme.spacing.s};
  height: 40px;
  ${Font14};
  font-family: ${theme.fonts.base};
  line-height: 24px;
  color: ${theme.colors.otterWarmBlack};
  background-color: ${theme.colors.white};
  border: 1px solid ${theme.colors.newLightGrey};
  border-radius: 8px;
  outline: none;
  width: 100%;
  caret-color: ${theme.colors.horizonOrange};

  ::placeholder {
    color: ${theme.colors.darkeyGrey};
  }

  :hover {
    border-color: ${theme.colors.darkeyGrey};
  }
  :active,
  :focus {
    border-color: ${theme.colors.horizonOrange};
  }
  :disabled {
    background-color: ${theme.colors.lighterGrey};
    pointer-events: none;
  }

  ${(p) => p.invalid && `border-color ${theme.colors.error};`};
`

export const StyledInputError = styled.p`
  margin: 0;
  ${Font12};
  min-height: 16px;
  margin-top: -${theme.spacing.s};
  margin-bottom: ${theme.spacing.s};
  color: ${theme.colors.error};
`

export const StyledInputLabelWrapper = styled.div`
  position: relative;
`

export const StyledLabel = styled.label`
  ${Font12};
  color: ${theme.colors.darkeyGrey};
  position: absolute;
  transition: all 0.3s ease;
  top: -18px;
  left: 16px;
`
export const StyledInputLabel = styled.label`
  position: absolute;
  top: -18px;
  left: 16px;
  min-width: max-content;
  ${Font12};
  color: ${theme.colors.darkeyGrey};
  transition: all 0.3s ease;
`
